import AtosLogoFull from './Atos-logo.png';

export const LogoFull = () => {
  return <img src={AtosLogoFull} alt="" height="50" />;
};
